import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_mst_entity_payment_method_RowClass,
  bl_fi_mst_entity_payment_method_RowInterface
} from '../../../dbschema/index';

export class EntityPaymentMethodContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_payment_method: bl_fi_mst_entity_payment_method_RowInterface = new bl_fi_mst_entity_payment_method_RowClass();
}
